import { normalizeUrl, titleForItem } from '@/pages/Result/utils.ts';
import { Box } from '@mantine/core';
import React from 'react';

type props = {
  item: string;
};

const UrlViewer = ({ item }: props) => {
  const src = normalizeUrl(item);
  return (
    <Box w="100%" h="100%">
      <iframe
        title={titleForItem(item)}
        src={src}
        sandbox="allow-scripts allow-same-origin"
        referrerPolicy="no-referrer"
        loading="lazy"
        style={{ border: 0, width: '100%', height: '100%' }}
      />
    </Box>
  );
};

export default UrlViewer;
